// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************
const SHOW_GEO_SUCCESS = "SHOW_GEO_SUCCESS";
const SHOW_GEO_SUCCESS_NO_LIMIT = "SHOW_GEO_SUCCESS_NO_LIMIT";

// ******************************************************************** rulePackRules **********************************************************************

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_GEO_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccessNoLimit(payload) {
  return {
    type: SHOW_GEO_SUCCESS_NO_LIMIT,
    payload: payload,
  };
}

// ******************************************************************** rulePackRules **********************************************************************

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** GeoFences *******************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function GeoFences(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/ta/GeoFences", {
        params: { page: params.page - 1, limit: params.limit },
      })
      .then((r) => {
        dispatch(_showSuccess(r));
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

// ***************************************************************** GeoFencesNoLimit *******************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function GeoFencesNoLimit(callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/ta/GeoFences")
      .then((r) => {
        dispatch(_showSuccessNoLimit(r));
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Number} rule
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
// export function showForm(rule, params = {}, callback = () => {
// }) {
//   return (dispatch, gs, api) => {
//     api.get(`/ta/GeoFences/${rule}`, {page:0,limit:20})
//       .then((res) => {
//         dispatch(_storeSuccess(res));
//         callback(undefined, res);
//       })
//       .catch((err) => {
//         app.error(
//           err, 'routes.home.attendance.rules', 'Rule',
//           app.translate('.خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید'),
//         );
//         callback(err);
//       });

//   };
// }

/**
 *
 * @param {Object} data
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function AddGeoFences(params = {}, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post("/ta/GeoFences", { data: { geofence: data } })
      .then((r) => {
        // app.message(r.message);
        app.message(app.translate("routes.home.map.GeoFence Created"));
        dispatch(GeoFences({ page: params.pageCount, limit: params.limit }));
      })
      .catch((e) => {
        console.log(e);
      });
    // api.post('/ta/GeoFences', {data})
    //   .then((r) => {
    //     dispatch(_storeSuccess(r));
    //      callback(r);
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };
}

/**
 *
 * @param {Object} params
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function EditGeoFences(params = {}, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .put(`/ta/GeoFences/${params.id}`, { data: { geofence: data } })
      .then((r) => {
        app.message(app.translate("routes.home.map.Resource Updated"));
        dispatch(GeoFences({ page: params.pageCount, limit: params.limit }));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function DeleteGeoFences(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .delete(`/ta/GeoFences/${params.id}`)
      .then((r) => {
        app.message(app.translate("routes.home.map.Delete Success"));
        dispatch(GeoFences({ page: params.pageCount, limit: params.limit }));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

/**
 *
 * @return {Function}
 */
export function emptyRulePacks() {
  return _indexSuccess({ data: { rulePacks: [] }, meta: {} });
}

/**
 *
 * @return {Function}
 */
export function emptyRule() {
  return _showRule({ data: { rule: {} } });
}

// ******************************************************************** rulePackRules **********************************************************************

/**
 *
 * @return {{type: String, payload: Object}}
 */
// export function emptyRulePack() {
//   return _showSuccess({data: {rulePack: {}}});
// }

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    rulePacks: [],
    rulePack: {},
    rulePackRules: [],
    rulePackRule: {},
    rule: {},
    metaRulePacks: {},
    metaRulePackRules: {},
    workshops: [],
    pageMeta: {},
  },
  action
) {
  let rulePacks;
  let rulePack;
  let _index;
  switch (action.type) {
    case SHOW_GEO_SUCCESS:
      return Object.assign({}, state, {
        geoFences: action.payload.data.geoFences,
        meta: action.payload.meta,
      });
    case SHOW_GEO_SUCCESS_NO_LIMIT:
      return Object.assign({}, state, {
        geoFencesNoLimit: action.payload.data.geoFences,
        meta: action.payload.meta,
      });
    default:
      return state;
  }
}
